import { render, staticRenderFns } from "./ProfilePictureModal.vue?vue&type=template&id=13a06db3&scoped=true&"
import script from "./ProfilePictureModal.vue?vue&type=script&lang=js&"
export * from "./ProfilePictureModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a06db3",
  null
  
)

export default component.exports